export const basePath = process.env.NODE_ENV === 'production' ? '' : ''

export default {
  download: basePath + '', // 下载
  uoload: '/common/api/upload', // 上传
  home: {
    position: '/card/ioticcid/imeigps/page_imeigps', // 查询定位分页

    getFenceLine: '/card/ioticcid/imeifencelist/select_imeifencelis', // 查询围栏坐标

    getFenceList: '/card/ioticcid/imeifence/page_imeifence', // 查看围栏
    addFence: '/card/ioticcid/imeifence/insert_imeifence', // 增加围栏
    deleteFence: '/card/ioticcid/imeifence/delete_imeifence', // 删除围栏
    viewFence: '/card/ioticcid/imeifencelist/select_imeifencelist' //查询围栏坐标
  },

  // 用户
  user: {
    openId: '/card/mLoginOpenid', // 获取openId
    code: '/card/getSmsCode', // 获取验证码
    login: '/card/mLoginPhone', // 登录
    logout: '/card/mlogout', // 注销
    userPhone: '/card/getmUserData', // 获取用户手机接口
    infoo: 'websocket/socket',
    shutdown: '/card/ioticcid/imei/update_imei_operate', // 关机
    addTouXiang: '/card/school/school_student/insert_school_student_photo', // 添加头像
    getTouXiang: '/card/school/school_student/select_school_student_photo' // 获取头像
  },

  // 消息
  message: {
    messageState: '/card/messagecard/message_card/message_state', // 查询是否已读
    schoolNotice: '/card/messagecard/message_notice_receive/page_message_notice_receive', // 查看学校通知
    editSchoolNotice: '/card/messagecard/message_notice_receive/update_message_notice_receive', // 修改学校通知
    work: '/card/messagecard/message_work_student/page_message_work_student', // 查询学生作业
    editWork: '/card/messagecard/message_work_student/update_message_work_student', // 修改学生作业
    card: '/card/messagecard/message_card/page_message_card', // 查询设备记录
    editCard: '/card/messagecard/message_card/update_message_card' // 修改设备记录
  },

  // 考勤
  attendance: {
    attendance: '/card/clock/clock_in_rec/page_clock_in_rec_student'
  },

  student: {
    info: '/card/school/school_student_family/select_school_family_student_msg' // 学生信息
  },

  my: {
    studentInfo: '/card/ioticcid/imei/page_imei', // 获取学生信息
    editDearPhone: '/card/ioticcid/imei/update_imei_phone', // 修改学生卡亲情号
    mute: '/card/school/school_mute_param/update_school_mute_param', // 静音时间段查看
    teacher: '/card/school/school_student/select_school_student_teacher', // 教师通讯录

    // 支付
    getMoney: '/card/cardpaySelectBalance', // 获取余额
    zfbPay: 'card/cardpayCreateOrders', //支付宝支付
    getOrders: '/card/wxpayCreateOrders',
    getList: '/card/pay/money_pay_school_param/select_money_pay_school_param', // pay获取订单列表

    // 订单记录
    rechargeList: '/card/pay/money_pos_orders/page_money_pos_orders', //充值记录
    payList: '/card/pay/money_pay_orders/page_money_pay_orders', // 缴费记录
    recordList: '/card/pay/money_pos_record/page_money_pos_record', //消费记录

    leave: '/card/clock/leave_rec/insert_leave_rec', //请假
    leaveList: '/card/clock/leave_rec/page_leave_rec'
  },

  //基本操作
  baseinfo:{ 
    getschoollist:'/api/getschoollist',
    getgradelist:'/api/getgradelist',
    classlist:'/api/getclasslist',
    checkstudent:'/api/checkstudent',
    checkguardian:'/api/checkguardian',
    bindaddguardian:'/api/bindaddguardian',
    bindguardian:'/api/bindguardian',
    bindotherchild:'api/bindotherchild',
    addguardian:'/api/addguardian',
    delguardian:'/api/delguardian',
    getguardianlist:'/api/getguardianlist',
    getgradeclass:'/api/getgradeclass',
    getchildlist:'/api/getchildlist',
    getchildinfo:'/api/getchildinfo',
    getsmscode:"/api/getsmscode",
    verifysmscode:"/api/verifysmscode",
    canceluser:"/api/canceluser"

  },
  //学生卡操作
  studentcard:{
    getaddressbook:'/api/getaddressbook',
    addfamilyphone:'/api/addfamilyphone',
    delfamilyphone:'/api/delfamilyphone',
    modifyfamilyphone:'/api/modifyfamilyphone',
    getdevicestatus:'/api/getdevicestatus',
    getmuteinfo:'/api/getmuteinfo',
    getlastgps:'/api/getlastgps',
    gettrackdata:'/api/getgpstrackdata',
    binddevice:'/api/binddevice',
    unbinddevice:'/api/unbinddevice',
    getweilanlist:'/api/getweilanlist',
    addweilaninfo:'/api/addweilaninfo',
    delweilaninfo:'/api/delweilaninfo',
    poweroff:'/api/poweroff',
    devicesendmsg:'/api/devicesendmsg',
    getdevicesendmsglist:'/api/getdevicesendmsglist',
    updatestudentphone:"/api/updatestudentphone"
  },
  //消息
  msg:{
    getschoolmsg:'/api/getschoolmsg',
    gethomeworkmsg:'/api/gethomeworkmsg',
    getdevicemsg:'/api/getdevicemsg'
  },
  //考勤
  kaoqin:{
    getstudentkaoqin:'/api/getstudentkaoqin',
    getstudentschooltrack:'/api/getstudentschooltrack'
  },
  //缴费
  payitem:{
    getstudentorderlist:'/api/getstudentorderlist',
    getschoolpayitem:"/api/getschoolpayitem",
    submitwxorder:"/api/submitwxorder",
  },
  //记录
  record:{
    getchargelist:'/api/getstudentchargelist',
    getpayfeelist:'/api/getstudentpaylist',
    getconsumelist:'/api/getstudentconsumelist'
  },
  //请假
  leave:{
    studentqingjia:"/api/studentqingjia", 
    qingjialist:"/api/qingjialist"
  },
  onecard:{
    getcardmoney:'/api/getcardmoney',
    onecardcharge:'/api/cardcharge'
  }

}
